import { UhfConfig, UhfConfigGeneratorFn } from "../models";

export const isUhfConfigGeneratorFn = (
  config: Readonly<UhfConfig> | UhfConfigGeneratorFn | undefined
): config is UhfConfigGeneratorFn => (config ? typeof config === "function" : false);

const cdataStart = "<![CDATA[";
const cdataEnd = "]]>";
export const extractUhfContentInTags = (str: string, tag: string): string => {
  const openingTag = `<${tag}>`;
  const closingTag = `</${tag}>`;

  const startIndex = str.indexOf(openingTag);
  const endIndex = str.indexOf(closingTag);

  if (startIndex !== -1 && endIndex !== -1) {
    const contentStartIndex = startIndex + openingTag.length;
    const result = str.slice(contentStartIndex, endIndex).trim();

    if (result.startsWith(cdataStart) && result.endsWith(cdataEnd)) {
      // Extract the content between the CDATA tags
      return result.slice(cdataStart.length, result.length - cdataEnd.length);
    }

    return result;
  }
  return "";
};
